module.exports = __webpack_public_path__ + "static/media/Logo White.c90f0228.png";